import React, {useEffect, useState} from 'react';
import {Button} from 'react-bootstrap';
import {LoginBackgroundImage, CenterLogin, CardLogin, AlertError} from './style'
import {Link, Redirect} from "react-router-dom";
import {useForm} from "../../_hooks/useForm";
import {useDispatch, useSelector} from 'react-redux';
import {getCurrentUser, userLogin} from '../../_store/_actions/repositoryUserActions';
import validator from 'validator';
import {setError, removeError, hideBookingBar, showNavBar, hideNavBar} from './../../_store/_actions/uiActions';
import {FaUnlockAlt} from 'react-icons/fa';
import ReactLoading from 'react-loading';
import {getData, savePartner, savePartnerID} from "../../_store/_actions/repositoryDataActions";
import {useQuery} from "../../_hooks/useQuery";

const LoginPage = (props) => {

    const dispatch = useDispatch();
    const {msgError, loading} = useSelector(state => state.ui);
    const [isLoading, setIsLoading] = useState(false);
    const [redirectTo, setRedirectTo] = useState(false);
    const [displayLogin, setDisplayLogin] = useState(false);

    const [formValues, handleInputChange] = useForm({
        email: '',
        password: ''
    });

    const {email, password} = formValues;
    const query = useQuery();
    let token = query.get("token");

    const handleLogin = (e) => {
        e.preventDefault();
        if (isFormValid()) {
            setIsLoading(true);

            dispatch(userLogin({email, password})).then((response) => {
                if (response.status === 200) {
                    dispatch(getData(`/partner/ByEmail/${email}`, props)).then((response) => {
                        setIsLoading(false);
                        if (response.status === 200) {
                            // Lanzo la actualización del partnerId dentro de la sección del partnet para que wallet tenga acceso
                            dispatch(savePartner(response.data));
                            if (response.data.statusDescription === 'PENDING' || response.data.userId === null) {
                                props.history.push("/membership");
                            } else {
                                dispatch(showNavBar());
                                /* We send to Wallet Home */
                                props.history.push("/");
                            }
                        }
                    }).catch(error => {
                        setIsLoading(false);
                        props.history.push("/membership");
                    });
                }
            }).catch(error => {
                setIsLoading(false);
            });

        }
    }

    const isFormValid = () => {
        if (!validator.isEmail(email)) {
            dispatch(setError('Email is invalid!'))
            return false;
        }

        if (password.trim().length === 0) {
            dispatch(setError('Password is required!'))
            return false;
        }

        dispatch(removeError());

        return true;
    }

    useEffect(() => {
        dispatch(removeError());
        dispatch(hideBookingBar());
        dispatch(hideNavBar());

        if (token !== null) {
            sessionStorage.setItem('token_security', token);
            dispatch(getCurrentUser()).then( (response) => {
                if (response.status === 200) {
                    dispatch(getData(`/partner/ByEmail/${response.data.email}`, props)).then((response) => {
                        if (response.status === 200) {
                            dispatch(savePartner(response.data));
                        }
                    });
                    setRedirectTo(true);
                } else {
                    setDisplayLogin(true);
                }

            }).catch((error) => {
                setDisplayLogin(true);
            });
        } else {
            setDisplayLogin(true);
        }

    }, [])

    if(redirectTo){
        return <Redirect to='/' />
    }

    return (
        <>
            {
                displayLogin ? (
                    <section id="content">
                        <section className="content-wrap nopadding ">
                            <LoginBackgroundImage className="section nopadding nomargin">

                                {
                                    isLoading &&
                                    <ReactLoading className="loading" type="spin" color="#143899" height={'80px'}
                                                  width={'80px'}/>
                                }

                                <div className="container-fluid vertical-middle divcenter clearfix">


                                    <CenterLogin>

                                        <CardLogin className="card divcenter noradius noborder">
                                            <div className="logo nomargin"></div>

                                            <div className="card-body">

                                                {
                                                    msgError &&
                                                    <AlertError>
                                                        {msgError}
                                                    </AlertError>
                                                }

                                                <form id="login-form" name="login-form" className="nobottommargin"
                                                      onSubmit={handleLogin}>
                                                    <h3>Login to your Account</h3>

                                                    <div className="col_full">
                                                        <label htmlFor="login-form-email">Email:</label>
                                                        <input type="text" id="email"
                                                               name="email"
                                                               value={email}
                                                               onChange={handleInputChange}
                                                               className="form-control not-dark"/>
                                                    </div>

                                                    <div className="col_full">
                                                        <label htmlFor="login-form-password">Password:</label>
                                                        <input type="password" id="password"
                                                               name="password"
                                                               value={password}
                                                               onChange={handleInputChange}
                                                               className="form-control dark"/>
                                                    </div>

                                                    <div className="col_full nobottommargin">
                                                        <Button type="submit"
                                                                className="button button-3d button-black nomargin"
                                                                id="login-form-submit"
                                                                name="login-form-submit"
                                                                disabled={loading}
                                                        ><FaUnlockAlt/> Login
                                                        </Button>
                                                        <a className="fright">Forgot Password?</a>
                                                    </div>
                                                    <div className="col_full pt-5 center">
                                                        <span>Don’t have a Shared Economy account yet? </span><Link
                                                        to="/register">Sign Up</Link>
                                                    </div>

                                                </form>
                                            </div>
                                        </CardLogin>

                                    </CenterLogin>

                                </div>
                            </LoginBackgroundImage>
                        </section>

                    </section>
                ): (null)
            }

        </>
    )
}

export default LoginPage;